module.exports = __webpack_public_path__ + "static/media/CeciliaPortada.996d0f9d.png";